import QuestionItemCard from "pages/ManagementPage/questionSection/questionItemCard/QuestionItemCard/QuestionItemCard";

export default QuestionItemCard;
